const isEmail = (text: string) => {
  const pattern = [
    '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]',
    '{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
  ].join('');
  const regex = new RegExp(pattern);
  return regex.test(text);
};

/**
 * Converts a username into the pseudo-email used by Firebase Auth for username-only accounts.
 * Mirrors audit-lite's `firebaseRepository.signIn` (packages/app/shared/repository/firebase-repository.ts):
 * username accounts are created in Firebase with the email `${username}@username.username`.
 */
const toUsernameLoginEmail = (username: string) => `${username.trim().toLowerCase()}@username.username`;

export { isEmail, toUsernameLoginEmail };
